export default class MemberProfilesJwtService {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.memberProfilesEndpoint}/${id}`, payload)
  }

  updatePersonal(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.memberProfilesEndpoint}/${id}/personal`, payload)
  }

  updateMinistry(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.memberProfilesEndpoint}/${id}/ministry`, payload)
  }

  updateMemberProfile(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.memberProfilesEndpoint}/${id}/member-profile`, payload)
  }

  updateStations(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.memberProfilesEndpoint}/${id}/stations-served`, payload)
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.memberProfilesEndpoint, {
      params
    })
  }

  updateAvatar(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.memberProfilesEndpoint}/${id}/avatar`, payload)
  }

  get(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.memberProfilesEndpoint}/${id}`)
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.memberProfilesEndpoint}/${id}`)
  }

  downloadMemberData(id, params = {}) {
    return this.axiosIns.get(
      `${this.jwtConfig.main.memberProfilesEndpoint}/${id}/download`,
      {
        responseType: "blob",
        params
      }
    );
  }

  linkSpouse(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.memberProfilesEndpoint}/${id}/spouse`, payload)
  }
}
